import { useMemo, type CSSProperties } from "react";
import { range, rand } from "../utils/random";
import type { EffectProps } from "./types";

export function Strawberries({ count = 28 }: EffectProps = {}) {
  const berries = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        left: `${rand(0, 100)}vw`,
        size: `${rand(20, 40)}px`,
        fallDuration: `${rand(7, 13)}s`,
        spinDuration: `${rand(3, 7)}s`,
        delay: `${rand(-13, 0)}s`,
        opacity: rand(0.7, 1),
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {berries.map(b => (
        <span
          key={b.id}
          className="fx-particle fx-strawberry"
          style={
            {
              left: b.left,
              top: 0,
              fontSize: b.size,
              opacity: b.opacity,
              animationDuration: `${b.fallDuration}, ${b.spinDuration}`,
              animationDelay: `${b.delay}, ${b.delay}`,
            } as CSSProperties
          }
        >
          🍓
        </span>
      ))}
    </div>
  );
}
